import { formatDateForExport, formatVolumeCell } from 'utils/helpers/format';

const summaryColumns = [
  {
    field: 'reconId',
    headerName: 'Recon. Id',
    sortable: true,
    width: 200,
  },
  {
    field: 'fromLocation',
    headerName: 'From Location',
    sortable: true,
    width: 200,
  },
  {
    field: 'toLocation',
    headerName: 'To Location',
    sortable: true,
    width: 200,
  },
  {
    field: 'status',
    headerName: 'Status',
    sortable: true,
    width: 150,
  },
  {
    field: 'transferVolume',
    headerName: 'Transfer Volume (bbls)',
    sortable: true,
    type: 'number',
    valueFormatter: formatVolumeCell,
    width: 200,
  },
  {
    field: 'transferDate',
    headerName: 'Transfer Date',
    sortable: true,
    type: 'dateTime',
    valueFormatter: formatDateForExport('MM/dd/yyyy'),
    width: 200,
  },
  {
    field: 'bookedDate',
    flex: 1,
    headerName: 'Booked Date',
    minwidth: 360,
    sortable: true,
    type: 'dateTime',
  },
];

export default summaryColumns;
